import { gql } from '@apollo/client';

// ===== Types =====

export interface AddressInvalidType {
  id: string;
  addressHash: string;
  normalizedStreet: string;
  normalizedUnit?: string | null;
  city: string;
  state: string;
  zipcode: string;
  invalidReason: string;
  dpvMatchCode?: string | null;
  apiSource?: string | null;
  firstSeenAt: string;
  lastCheckedAt: string;
  retryAfter: string;
  checkCount: number;
  hitCount: number;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface AddressInvalidPageResponse {
  content: AddressInvalidType[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface GetAddressInvalidListResponse {
  addressInvalidList: AddressInvalidPageResponse;
}

// ===== Query =====

export const GET_ADDRESS_INVALID_LIST = gql`
  query GetAddressInvalidList(
    $addressHash: String
    $normalizedStreet: String
    $normalizedUnit: String
    $zipcode: String
    $page: Int!
    $size: Int!
  ) {
    addressInvalidList(
      addressHash: $addressHash
      normalizedStreet: $normalizedStreet
      normalizedUnit: $normalizedUnit
      zipcode: $zipcode
      page: $page
      size: $size
    ) {
      content {
        id
        addressHash
        normalizedStreet
        normalizedUnit
        city
        state
        zipcode
        invalidReason
        dpvMatchCode
        apiSource
        firstSeenAt
        lastCheckedAt
        retryAfter
        checkCount
        hitCount
        createdAt
        updatedAt
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

// ===== Mutation =====

export const DELETE_ADDRESS_INVALID = gql`
  mutation DeleteAddressInvalid($id: Long!) {
    deleteAddressInvalid(id: $id)
  }
`;